<div class="container-fluid chat-input-fields-container">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="col-12 chat-message-container">
      <div class="container-fluid">
        <!-- TODO: header for chat message. Could be uncommented in future -->
        <!-- <div class="col-12">
        <input class="chat-input-title" type="text" placeholder="title" formControlName="header"/>
      </div> -->

      <div class="col-12">
        <textarea
          placeholder="{{ 'CHAT.MESSAGE_FORM.MESSAGE' | translate }}"
          formControlName="message"
          maxlength="{{ messageLengthLimit }}"
        ></textarea>
        <div class="message-limit">{{ messageLength }}/{{ messageLengthLimit }}</div>
      </div>
    </div>
  </div>

  <div class="col-12 chat-attachment-block desktop-element">
    <button class="btn btn-attachment" type="button" (click)="onDesktopAttachmentClick()" [disabled]="attachmentButtonDisabled">
      <img src="assets/icons/component_icons/cloud-upload-main-icon.png" alt="{{ 'CHAT.MESSAGE.ATTACHMENTS' | translate }}" />
      {{ 'CHAT.MESSAGE.ATTACHMENTS' | translate }}
    </button>
  </div>

  <div class="row">
    <div class="mobile-buttons-block chat-attachment-block">
      <div class="mobile-buttons-group">
        <button class="btn btn-attachment" type="button" (click)="onOpenAttachmentSidebarClick()">
          <img src="assets/icons/component_icons/cloud-upload-main-icon.png" alt="{{ 'CHAT.MESSAGE.ATTACHMENTS' | translate }}" />
          {{ filesCount }}
        </button>
        @if (isTenantInvolved) {
          <astral-checkbox [control]="form.controls['visibleForTenant']"></astral-checkbox>
        }
      </div>
      <button class="btn btn-submit" type="submit" [disabled]="sendButtonDisabled">
        @if (isLoading) {
          <span class="spinner"></span>
        }
        @if (!isLoading) {
          <img src="assets/icons/component_icons/telegram-white-icon.png" />
        }
      </button>
    </div>
  </div>

  <div class="col-12 desktop-element">
    <app-multi-file-upload
      #fileUploadRef
      [allowedMimeTypes]="mimes"
      [forms]="form.controls['attachments']"
      [maxFiles]="maxFiles"
      [externalClickEvent]="attachmentDesktopClickObservable$"
    ></app-multi-file-upload>
  </div>

  <div class="col-12 chat-checkbox-block desktop-element">
    @if (isTenantInvolved) {
      <astral-checkbox [control]="form.controls['visibleForTenant']"></astral-checkbox>
    }
  </div>

  <div class="col-12 chat-submit-block desktop-element">
    <button class="btn btn-submit" type="submit" [disabled]="sendButtonDisabled">
      @if (isLoading) {
        <span class="spinner"></span>
      }
      @if (!isLoading) {
        <img src="assets/icons/component_icons/telegram-white-icon.png" />
        }{{ 'CHAT.MESSAGE.SEND' | translate }}
      </button>
    </div>

    <ng-template #attachmentsSidebarContent>
      <div class="container-fluid chat-input-fields-container sidebar-container">
        <div class="col-12">
          <h2>{{ 'CHAT.MESSAGE.ADD_ATTACHMENT' | translate }}</h2>
        </div>

        <div class="col-12 chat-attachment-block">
          <app-multi-file-upload
            #fileUploadRef
            [allowedMimeTypes]="mimes"
            [forms]="form.controls['attachments']"
            [maxFiles]="maxFiles"
            [externalClickEvent]="attachmentMobileClickObservable$"
          ></app-multi-file-upload>
        </div>

        <div class="col-12 chat-attachment-block">
          <button
            class="btn btn-attachment mobile-element"
            type="button"
            (click)="onMobileAttachmentClick()"
            [disabled]="attachmentButtonDisabled"
            >
            <img src="assets/icons/component_icons/cloud-upload-main-icon.png" alt="{{ 'CHAT.MESSAGE.ATTACHMENTS' | translate }}" />
            {{ 'CHAT.MESSAGE.ATTACHMENTS' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </form>
</div>
